module.exports = store_config;